import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  // Use admin token in /admin routes, user token elsewhere
  const isAdmin = window.location.pathname.startsWith("/admin");
  const token = isAdmin
    ? localStorage.getItem("kha_admin_token")
    : localStorage.getItem("kha_user_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const path = window.location.pathname;
    if (status === 401 && path.startsWith("/admin") && !path.endsWith("/admin/login")) {
      localStorage.removeItem("kha_admin_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export default api;

export function imgUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
}
